var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkIconWithBlackBg = function SvgQuestionMarkIconWithBlackBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 6.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.814 2.074c1.641 0 2.632.98 2.632 2.423 0 .948-.506 1.421-1.134 1.895-.573.44-.87.782-.87 1.366v.32H5.13v-.375c0-.738.408-1.223 1.058-1.751.54-.42.914-.794.914-1.433 0-.76-.473-1.289-1.288-1.289s-1.29.485-1.356 1.278l-1.31-.088c.077-1.432 1.101-2.346 2.666-2.346m-.045 6.885c.441 0 .805.353.805.804 0 .43-.364.782-.805.782a.785.785 0 0 1-.782-.782.79.79 0 0 1 .782-.804"
  })));
};
export default SvgQuestionMarkIconWithBlackBg;